import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './Components.css';
import Card from 'react-bootstrap/Card'
import { CardDeck,Button } from 'react-bootstrap';
import react_form from './images/react-step-form.png';
import product_page from './images/product_landing_page.png';
import survey_form from './images/surveyform.png';
import bookmarker from './images/bookmarker.png';

class Mywork extends Component {
   constructor(props){
       super(props);
   }
    render() { 
        return ( 
            <section id="mywork">
               <div className="mywork">
                   
                   <div className="container-fluid ">
                       <h1 className="text-center pt-3">MY WORK<hr/></h1>
                       <div className="row row-cols-1 row-cols-md-3 my-5">
                           
                           <div class="col mb-4">
                              <Card className="card shadow" style={{ width: '18rem' }}>
                                <Card.Img variant="top" src={react_form} />
                                <Card.Body>
                                    <Card.Title>React Step Form</Card.Title>
                                    <Card.Text>
                                     Some quick example text to build on the card title and 
                                     make up the bulk of the card's content.
                                    </Card.Text>
                                    <Button className="card-btn" variant="primary" href="https://phanindra-reddy.github.io/react-step-form/" target="_blank">Demo</Button>
                                    <Button className="card-btn" variant="primary" href="" target="_blank">Github Code</Button>
                                </Card.Body>
                              </Card>
                           </div>

                           <div class="col mb-4">
                              <Card className="shadow" style={{ width: '18rem' }}>
                                <Card.Img variant="top" src={product_page} />
                                <Card.Body>
                                    <Card.Title>Product Landing Page</Card.Title>
                                    <Card.Text>
                                     Some quick example text to build on the card title and 
                                     make up the bulk of the card's content.
                                    </Card.Text>
                                    <Button className="card-btn" variant="primary" href="https://phanindra-reddy.github.io/product-landing-page/" target="_blank">Demo</Button>
                                    <Button className="card-btn" variant="primary" href="https://github.com/Phanindra-Reddy/product-landing-page/" target="_blank">Github Code</Button>
                                </Card.Body>
                              </Card>
                           </div>

                           <div class="col mb-4">
                              <Card className="shadow" style={{ width: '18rem' }}>
                                <Card.Img variant="top" src={survey_form} />
                                <Card.Body>
                                    <Card.Title>Survey Form</Card.Title>
                                    <Card.Text>
                                     Some quick example text to build on the card title and 
                                     make up the bulk of the card's content.
                                    </Card.Text>
                                    <Button className="card-btn" variant="primary" href="https://phanindra-reddy.github.io/surveyform/" target="_blank">Demo</Button>
                                    <Button className="card-btn" variant="primary" href="https://github.com/Phanindra-Reddy/surveyform/" target="_blank">Github Code</Button>
                                </Card.Body>
                              </Card>
                           </div>

                           <div class="col mb-4">
                              <Card className="shadow" style={{ width: '18rem' }}>
                                <Card.Img variant="top" src={bookmarker} />
                                <Card.Body>
                                    <Card.Title>JS Bookmarker</Card.Title>
                                    <Card.Text>
                                     Some quick example text to build on the card title and 
                                     make up the bulk of the card's content.
                                    </Card.Text>
                                    <Button className="card-btn" variant="primary" href="https://phanindra-reddy.github.io/bookmarker/" target="_blank">Demo</Button>
                                    <Button className="card-btn" variant="primary" href="https://github.com/Phanindra-Reddy/bookmarker/" target="_blank">Github Code</Button>
                                </Card.Body>
                              </Card>
                           </div>

                           <div class="col mb-4">
                              <Card className="shadow" style={{ width: '18rem' }}>
                                <Card.Img variant="top" src={react_form} />
                                <Card.Body>
                                    <Card.Title>Card Title</Card.Title>
                                    <Card.Text>
                                     Some quick example text to build on the card title and 
                                     make up the bulk of the card's content.
                                    </Card.Text>
                                    <Button className="card-btn" variant="primary" href="" target="_blank">Demo</Button>
                                    <Button className="card-btn" variant="primary" href="" target="_blank">Github Code</Button>
                                </Card.Body>
                              </Card>
                           </div>

                           <div class="col mb-4">
                              <Card className="shadow" style={{ width: '18rem' }}>
                                <Card.Img variant="top" src={react_form} />
                                <Card.Body>
                                    <Card.Title>Card Title</Card.Title>
                                    <Card.Text>
                                     Some quick example text to build on the card title and 
                                     make up the bulk of the card's content.
                                    </Card.Text>
                                    <Button className="card-btn" variant="primary" href="" target="_blank">Demo</Button>
                                    <Button className="card-btn" variant="primary" href="" target="_blank">Github Code</Button>
                                </Card.Body>
                              </Card>
                           </div>
                                                      
                       </div>

                        <div className="row justify-content-center">
                            <div className="col-md-12 col-lg-4">
                                <a
                                  className="btn  btn-outline-primary bg-primary border text-white mb-5 py-3 w-50"
                                  href="" target="_blank"
                                >
                                  More Projects
                                </a>
                            </div>
                        </div>

                    </div>

               </div>
            </section>
         );
    }
}
 
export default Mywork;
